import { action, createRequestTypes } from './base';

export const departmentActionTypes = {
  CREATE_DEPARTMENT: createRequestTypes('CREATE_DEPARTMENT'),
  GET_DEPARTMENT_BY_ID: createRequestTypes('GET_DEPARTMENT_BY_ID'),
  GET_DEPARTMENTS: createRequestTypes('GET_DEPARTMENTS'),
  UPDATE_DEPARTMENT: createRequestTypes('UPDATE_DEPARTMENT'),
  UPDATE_STATUS_DEPARTMENT: createRequestTypes('UPDATE_STATUS_DEPARTMENT'),
  DELETE_DEPARTMENT: createRequestTypes('DELETE_DEPARTMENT'),

};

/**
 *
 */
class DepartmentActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createDepartment = (payload, callback) => action(departmentActionTypes.CREATE_DEPARTMENT.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param createDepartmentLoading
   * @return {{type: *}}
   */
   createDepartmentLoading = (createDepartmentLoading) => action(departmentActionTypes.CREATE_DEPARTMENT.LOADING, {
     createDepartmentLoading,
   })

   /**
    *
    * @param createDepartment
    * @return {{type: *}}
    */
   createDepartmentSuccess = (createDepartment) => action(departmentActionTypes.CREATE_DEPARTMENT.SUCCESS, {
     createDepartment,
   })

  /**
   * @param page
   * @param keyword
   * @param orgId
   * @param limit
   * @param departmentId
   * @param tenantSellerId
   * @param callback
   * @param isAdmin
   * @param tenantId
   * @return {{type: *}}
   */
  getDepartments = (keyword, tenantId, page, limit, departmentId, callback, orgId, isAdmin, multipleSelectedTenantIds) => action(departmentActionTypes.GET_DEPARTMENTS.REQUEST, {
    keyword,
    tenantId,
    page,
    limit,
    departmentId,
    callback,
    orgId,
    isAdmin,
    multipleSelectedTenantIds,
  });

  /**
   *
   * @param getDepartmentsLoading
   * @return {{type: *}}
   */
  getDepartmentsLoading = (getDepartmentsLoading) => action(departmentActionTypes.GET_DEPARTMENTS.LOADING, {
    getDepartmentsLoading,
  })

  /**
   *
   * @param departments
   * @return {{type: *}}
   */
  getDepartmentsSuccess = (departments) => action(departmentActionTypes.GET_DEPARTMENTS.SUCCESS, {
    departments,
  })

  /**
   * @param departmentId
   * @param tenantId
   * @return {{type: *}}
   */
  getDepartmentById = (departmentId, tenantId) => action(departmentActionTypes.GET_DEPARTMENT_BY_ID.REQUEST, {
    departmentId,
    tenantId,
  })

  /**
   *
   * @param getDepartmentByIdLoading
   * @return {{type: *}}
   */
  getDepartmentByIdLoading = (getDepartmentByIdLoading) => action(departmentActionTypes.GET_DEPARTMENT_BY_ID.LOADING, {
    getDepartmentByIdLoading,
  });

  /**
   *
   * @param selectedDepartment
   * @return {{type: *}}
   */
   getDepartmentByIdSuccess = (selectedDepartment) => action(departmentActionTypes.GET_DEPARTMENT_BY_ID.SUCCESS, {
     selectedDepartment,
   });

  /**
   * @param payload
   * @param callback
   * @param history
   * @return {{type: *}}
   */
  updateDepartment = (payload, callback) => action(departmentActionTypes.UPDATE_DEPARTMENT.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param updateDepartmentLoading
   * @return {{type: *}}
   */
   updateDepartmentLoading = (updateDepartmentLoading) => action(departmentActionTypes.UPDATE_DEPARTMENT.LOADING, {
     updateDepartmentLoading,
   })

   /**
    *
    * @param updateDepartment
    * @return {{type: *}}
    */
   updateDepartmentSuccess = (updateDepartment) => action(departmentActionTypes.UPDATE_DEPARTMENT.SUCCESS, {
     updateDepartment,
   })

   /**
    * @param tenantId
    * @param departmentId
    * @param orgId
    * @param payload
    * @param callback
    * @return {{type: *}}
    */
    updateDepartmentStatus = (payload, callback) => action(departmentActionTypes.UPDATE_STATUS_DEPARTMENT.REQUEST, {
      payload, callback,
    })

    /**
     * @param updateDepartmentStatusLoading
     * @return {{type: *}}
     */
    updateDepartmentStatusLoading = (updateDepartmentStatusLoading) => action(departmentActionTypes.UPDATE_STATUS_DEPARTMENT.LOADING, {
      updateDepartmentStatusLoading,
    })

    /**
     * @param tenantId
     * @param departmentId
     * @param orgId
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
      deleteDepartment = (payload, callback) => action(departmentActionTypes.DELETE_DEPARTMENT.REQUEST, {
        payload, callback,
      })

      /**
       * @param updateSOStatusLoading
       * @param deleteDepartmentLoading
       * @return {{type: *}}
       */
       deleteDepartmentLoading = (deleteDepartmentLoading) => action(departmentActionTypes.DELETE_DEPARTMENT.LOADING, {
         deleteDepartmentLoading,
       })
}
export default new DepartmentActions();
